import React, { AllHTMLAttributes } from 'react';

type SwPageProps = AllHTMLAttributes<HTMLDivElement>;

export const SwPage = ({ children }: SwPageProps) => {
  return <div className="vl-page">{children}</div>;
};
